<template>
  <div v-if="food" class="flex-trow flex-trow-content">
    <div class="flex-td details-td"> {{food.food_group.name}} </div>
    <transition name="fade"><div v-if="isExpanded" class="flex-td aditional-info"> {{getFoodCalories(food.food_group)}} </div></transition>
    <transition name="fade"><div v-if="isExpanded" class="flex-td aditional-info"> {{food.food_group.cho_grams}} </div></transition>
    <transition name="fade"><div v-if="isExpanded" class="flex-td aditional-info"> {{food.food_group.lipid_grams}} </div></transition>
    <transition name="fade"><div v-if="isExpanded" class="flex-td aditional-info"> {{food.food_group.protein_grams}} </div></transition>
    <div class="flex-td"> 
      <EditableCellInput
        v-model="food.quantity"
        :state="$v.food.quantity.$invalid ? false : null "
      />
    </div>
    <div class="flex-td"> 
      <EditableCellInput
        v-model="food.portionsCalories"
        :state="$v.food.portionsCalories.$invalid ? false : null "
        @input="recalculateTotals"
      />
    </div>
    <div class="flex-td"> 
      <EditableCellInput
        v-model="food.portionsCHO"
        :state="$v.food.portionsCHO.$invalid ? false : null "
        @input="recalculateCalories"
      /> 
    </div>
    <div class="flex-td"> 
      <EditableCellInput
        v-model="food.portionsLipid"
        :state="$v.food.portionsLipid.$invalid ? false : null "
        @input="recalculateCalories"
      />
    </div>
    <div class="flex-td"> 
      <EditableCellInput
        v-model="food.portionsProtein"
        :state="$v.food.portionsProtein.$invalid ? false : null "
        @input="recalculateCalories"
      />
    </div>
  </div> 
</template>

<script>
import EditableCellInput from "../EditableCellInput";
import { decimal, integer, required, minValue } from 'vuelidate/lib/validators';

export default {
  name: "PortionsTableRow",
  components: { 
    EditableCellInput, 
  },
  model: {
    prop: "foodData",
    event: "change",
  },
  props: { 
    foodData: {
      type: Object,
      default: function () {
        return {
          food_group: {
            name: "",
            cho_grams: 0,
            lipid_grams: 0,
            protein_grams: 0,
          },
          quantity: 0,
          portionsCalories: 0,
          portionsCHO: 0,
          portionsLipid: 0,
          portionsProtein: 0,
        }
      },
    },
    isExpanded: Boolean
  },
  data: function() {
    return {
      food: this.foodData,
    }
  },
  validations: {
    food: { 
      quantity: {
        decimal,
        required
      },
      portionsCalories: {
        integer,
        required,
        minValue: minValue(0)
      },
      portionsCHO: {
        integer,
        required,
        minValue: minValue(0)
      },
      portionsLipid: {
        integer,
        required,
        minValue: minValue(0)
      },
      portionsProtein: {
        integer,
        required,
        minValue: minValue(0)
      },
    }
  },
  watch: {
    food: {
      handler: function(val) {
        this.$emit("change", val)
      },
    },
    "food.quantity": {
      handler: function (val) {
        this.food.portionsCalories = this.getQuantityByPortions(this.getFoodCalories(this.food.food_group), val)
        this.food.portionsCHO = this.getQuantityByPortions(this.food.food_group.cho_grams, val)
        this.food.portionsProtein = this.getQuantityByPortions(this.food.food_group.protein_grams, val)
        this.food.portionsLipid = this.getQuantityByPortions(this.food.food_group.lipid_grams, val)
        this.recalculateTotals()
      },
      immediate: true,
    },
  },
  methods: {
    recalculateCalories() {
      this.food.portionsCalories = this.getCaloriesByModifiedMacros()
      this.recalculateTotals()
    },
    recalculateTotals(){
      this.$emit("recalculate-totals")
    },
    getFoodCalories(food) {
      let protein = food.protein_grams
      let lipid = food.lipid_grams
      let cho = food.cho_grams
      return ((cho + protein) * 4 ) + (lipid * 9)
    },
    getQuantityByPortions(quantity, portions) {
      if (isNaN(quantity) || isNaN(portions)) {
        return "--"
      } else {
        return (quantity * portions).toFixed(0)
      }
    },
    getCaloriesByModifiedMacros(){
      let protein = this.food.portionsProtein
      let lipid = this.food.portionsLipid
      let cho = this.food.portionsCHO
      if (isNaN(protein) || isNaN(lipid) || isNaN(cho)) {
        return "--"
      } else {
        return ((Number(cho) + Number(protein)) * 4 ) + (Number(lipid) * 9)
      }
    }
  },
}
</script>

<style scoped lang="scss">
$portions-table-base-color: #517a51;
.flex-trow-content > .flex-td {
  flex: 1 0 6rem;
  padding-top: 0.1rem;
  padding-bottom: 0.1rem;
}

.flex-trow-content > .aditional-info {
  background-color: rgba($portions-table-base-color, 0.03);
}

.flex-trow-content > .flex-td.details-td {
  flex: 1 0 12rem;
}

.fade-enter-active {
  transition: all 1s;
}
.fade-leave-active {
  transition: all .4s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
  width: 0;
}

// Hide incremental arrows
/* Chrome, Safari, Edge, Opera */
.editable-cell input::-webkit-outer-spin-button,
.editable-cell input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
.editable-cell input[type=number] {
  -moz-appearance: textfield;
}

</style>